export enum EnumCommodity {
  GasNatural = 1,
  Electricidad
}
